<template>
    <div class="p-4 text-left">
        <p v-if="showTitle" class="mb-3 text-center text-lg font-bold text-gray-900">Priced to grow with you.</p>
        <table class="w-full text-sm">
            <thead>
                <tr class="border-b border-gray-300">
                    <th scope="col" class="pb-1.5 pr-4 text-left font-bold text-gray-900">Units Managed</th>
                    <th scope="col" class="pb-1.5 pr-4 text-left text-xs font-bold text-gray-900">Basic</th>
                    <th scope="col" class="pb-1.5 text-left font-bold text-gray-900">Pro</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="row in rows" :key="row.units" class="border-b border-gray-100 last:border-0">
                    <th scope="row" class="py-1.5 pr-4 text-left font-bold text-gray-900">{{ row.units }}</th>
                    <td class="py-1.5 pr-4 text-xs text-gray-600">{{ row.basic }}</td>
                    <td class="py-1.5 text-gray-900">
                        <span class="font-semibold">{{ row.pro }}</span>
                        <span class="ml-1 text-[0.65rem] italic text-gray-500">(billed annually)</span>
                    </td>
                </tr>
            </tbody>
        </table>
        <slot />
    </div>
</template>

<script setup>
// The "Starting at" tier table (86bcd9hg3): `rows` comes from buildStartingAtRows() in
// startingAtPopup.js. The default slot holds an optional call to action under the table.
defineProps({
    rows: {
        type: Array,
        required: true,
    },
    showTitle: {
        type: Boolean,
        default: false,
    },
})
</script>
